export const fieldNames = {
  name: 'name',
  files: 'files',
  description: 'description',
  availableToClient: 'availableToClient',
  fromDate: 'fromDate',
  toDate: 'toDate',
  clientId: 'clientId',
  typeId: 'typeId',
};
